// extracted by mini-css-extract-plugin
export var container = "_bm-1";
export var cornerButtonContainer = "_bm-5";
export var disabled = "_bm-2";
export var fileContainer = "_bm-4";
export var hiddenInput = "_bm-3";
export var widthContainer = "_bm-0";